import { http } from '@pendo/http';
import find from 'lodash/find';
import { ENTITY_TYPE_INTEGRATION, ENTITY_TYPE_SUBSCRIPTION } from './integration-constants';

// until the backend supports get by type, the frontend will do a simple find
export const get = async (type) => {
    const { data } = await http.get('/api/s/_SID_/integration');

    return find(data, { type });
};

export const create = async ({ type, data = {} }) => {
    return http.post(`/api/s/_SID_/integration/${type}`, data, { headers: { contentType: 'application/json' } });
};

export const update = async ({ type, data }) => {
    return http.put(`/api/s/_SID_/integration/${type}/data`, data, { headers: { contentType: 'application/json' } });
};

export const remove = async ({ type }) => {
    return http.delete(`/api/s/_SID_/integration/${type}/`);
};

export const sync = async ({ type, kind }) => {
    return http.post(`/api/s/_SID_/integration/${type}/sync/${kind}`, '');
};

export const push = async ({ type, kind }) => {
    return http.post(`/api/s/_SID_/integration/${type}/push/${kind}`, '');
};

export const getConfiguredIntegrations = async () => {
    const { data } = await http.get('/api/s/_SID_/integration');

    return data;
};

export const getIntegrationOauthStatus = async (type) => {
    const { data } = await http.get(`/api/s/_SID_/integration/${type}/auth/test`);

    return data;
};

export const getIntegrationSchema = async ({ type, schema, filter }) => {
    const filterStr = filter ? `?filter=${filter}` : '';
    const { data } = await http.get(`/api/s/_SID_/integration/${type}/schema/${schema}${filterStr}`);

    return data;
};

export function isConfiguredIntegration (integration) {
    return Object.keys(integration.config).length > 0;
}

export function isIntegrationOauth (oauthConfig) {
    return oauthConfig.uriConfig.entityType === ENTITY_TYPE_INTEGRATION;
}

export function isTokenOnlyOauth (oauthConfig) {
    return oauthConfig.uriConfig.entityType === ENTITY_TYPE_SUBSCRIPTION;
}
